<template>
  <v-card>
    <v-toolbar dark color="secondary">
      Set up nutrition block registration
    </v-toolbar>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-col cols="12" md="9">
          <v-autocomplete v-model="form.blockId" solo dense clearable :items="blockOptions" label="Select a block" />
        </v-col>
        <v-col cols="12" md="9">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.programStartDate"
                label="Block start date"
                prepend-icon="mdi-calendar"
                readonly
                dense
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="form.programStartDate" @input="menu = false" :allowed-dates="allowedDates" />
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="mode == 'CREATE'"
        :disabled="!(form.programStartDate && form.blockId)"
        @click="createBlock"
        color="primary"
        outlined
        :loading="saving"
      >
        Create
      </v-btn>
      <v-btn
        v-else
        :disabled="!(form.programStartDate && form.blockId)"
        color="primary"
        @click="editBlock"
        outlined
        :loading="saving"
      >
        Update block
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  NUTRITION_BLOCKS_QUERY,
  COACHING_NUTRITION_BLOCK_MUTATION,
  SUBSCRIPTION_NUTRITION_BLOCK_QUERY,
} from "@/graphql/queries/nutrition";

export default {
  name: "ManageNutritionBlock",
  props: {
    userId: {
      type: String,
      required: true,
    },
    subscriptionBlockId: {
      type: String,
      required: false,
    },
    mode: {
      type: String,
      default: "CREATE",
    },
    selectedBlockId: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      blockOptions: [],
      menu: false,
      saving: false,
      form: {
        programStartDate: null,
        blockId: null,
      },
      allowedDates: (val) => new Date(val).getUTCDay() === 1,
    };
  },
  watch: {
    selectedBlockId: function(val) {
      this.form.blockId = val;
    },
  },
  methods: {
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    createBlock() {
      this.saving = true;
      let input = {
        userId: this.userId,
        startDate: this.form.programStartDate,
        blockId: this.form.blockId,
      };
      this.$apollo
        .mutate({
          mutation: COACHING_NUTRITION_BLOCK_MUTATION,
          variables: {
            input: input,
          },
          refetchQueries: ["subscriptionActivityQuery"],
        })
        .then((result) => {
          this.saving = false;
          if (result.data.coachingSubscriptionNutritionBlockMutation.success) {
            this.$toasted.success("Nutrition block created", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
            this.handleClose();
          } else {
            this.$toasted.error("Something went wrong", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    editBlock() {
      this.saving = true;
      let input = {
        subscriptionBlockId: this.getId(this.subscriptionBlockId),
        blockId: this.form.blockId,
        startDate: this.form.programStartDate,
      };
      this.$apollo
        .mutate({
          mutation: COACHING_NUTRITION_BLOCK_MUTATION,
          variables: {
            input: input,
          },
          refetchQueries: ["subscriptionActivityQuery"],
        })
        .then((result) => {
          this.saving = false;
          if (result.data.coachingSubscriptionNutritionBlockMutation.success) {
            this.$toasted.success("Nurition block updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
            this.handleClose();
          } else {
            this.$toasted.error("Something went wrong", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    handleClose() {
      this.form = {
        programStartDate: null,
        blockId: null,
      };
      this.$emit("close");
    },
  },
  apollo: {
    nutritionBlocks: {
      query: NUTRITION_BLOCKS_QUERY,
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.blockOptions = [];
          response.data.nutritionBlocks.edges.forEach((item) => {
            // ignore paid for blocks
            this.blockOptions.push({
              text: item.node.title,
              value: this.getId(item.node.id),
            });
          });
        }
      },
    },
    nutritionSubscriptionBlock: {
      query: SUBSCRIPTION_NUTRITION_BLOCK_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          subscriptionBlockId: this.getId(this.subscriptionBlockId),
        };
      },
      skip() {
        return !this.subscriptionBlockId;
      },
      result(response) {
        if (response.data) {
          this.form.blockId = this.getId(response.data.nutritionSubscriptionBlock.nutritionBlock.id);
          this.form.programStartDate = response.data.nutritionSubscriptionBlock.startDate;
        }
      },
    },
  },
};
</script>
